import React, { use } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

const ProtectedRoute = ({ allowedRoles, children,allowedPage }) => {
  const { user, loading } = useAuth();


  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />; 
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
 
    return <Navigate to="/auth/v6/dash-board/unauthorized" replace />;
  }

  //nEW Logic

  
  // PAGE ACCESS CHECK (String to String)

  
    if (user.role === "adminuser") {

      if(user.accessAllow !=="AllAccess"){

      
  if (allowedPage && user.accessAllow !== allowedPage) {
    return <Navigate to="/auth/v6/dash-board/unauthorized" replace />;
  }

  }
}

  return children || <Outlet />; 
};

export default ProtectedRoute;
